import { rem, rgba } from 'polished'
import theme from 'styles/theme'

export const inputBorderColor = 'rgba(0, 0, 0, 0.2)' // dark ultra high
export const inputBorderColorFocus = 'rgba(0, 0, 0, 0.4)'
export const inputInvalidPlaceholderColor = rgba(theme.colors.negative, 0.5)
export const inputBorderRadius = '3px'

export const inputPaddingTop = rem(7)
export const inputPaddingBottom = rem(7)
export const inputPaddingLeft = '1rem'
export const inputPaddingRight = '1rem'
